











import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { InvoiceConsolidationTypes } from "@/data/enums/invoice";

// Types
import { IFiltersOptions } from "@/models/tables";

@Component
export default class InvoiceConsolidationEnabledField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: () => [] })
  public options!: IFiltersOptions[];

  @Prop({ default: null })
  public label!: string | null;

  // Getters

  public get invoiceConsolidationValue() {
    return this.value;
  }

  // Setters

  public set invoiceConsolidationValue(value) {
    this.$emit("input", value);
  }

  // Computed

  public get isInheriting() {
    return this.options.length;
  }

  public get invoiceConsolidationOptions() {
    if (this.options.length) return this.options;

    return [
      {
        value: InvoiceConsolidationTypes.ENABLED,
        leftLabel: this.$t("_sentence.invoice.include_when_consolidating")
      },
      {
        value: InvoiceConsolidationTypes.DISABLED,
        leftLabel: this.$t("_sentence.invoice.exclude_from_consolidation")
      }
    ];
  }
}
